// extracted by mini-css-extract-plugin
module.exports = {"container":"GamesListContainer_container__17hBp","anchor":"GamesListContainer_anchor__10Xeo"};